// For details please check: https://www.notion.so/welcome-to-volt/ADR-018-Debounce-delay-consistency-d507affdb47b439f8cdb5f7b2888eab0?pvs=4
export const DEBOUNCE_DEFAULT_TIME_IN_MS = 275 as const;
